module.exports = __webpack_public_path__ + "media/interview_etiquette/true_or_false-c5ec0806.png";